import * as types from "./types";

const clearStore = () => ({
  type: types.CLEAR_STORE
});

const addInvoices = invoices => ({
  type: types.ADD_INVOICES,
  payload: invoices
});

const removeInvoices = invoiceIds => ({
  type: types.REMOVE_INVOICES,
  payload: invoiceIds
});

/* Fetch Statement */

const fetchingStatementError = error => ({
  type: types.FETCHING_STATEMENT_ERROR,
  payload: error
});

const fetchingStatementSuccess = data => ({
  type: types.FETCHING_STATEMENT_SUCCESS,
  payload: data
});

const fetchingStatement = id => ({
  type: types.FETCHING_STATEMENT,
  payload: id
});
/* Fetch Statement */

/* Fetch Invoices */
const fetchingInvoiceListError = error => ({
  type: types.FETCHING_INVOICE_LIST_ERROR,
  payload: error
});

const fetchingInvoiceListSuccess = data => ({
  type: types.FETCHING_INVOICE_LIST_SUCCESS,
  payload: data
});

const fetchingInvoiceList = data => ({
  type: types.FETCHING_INVOICE_LIST,
  payload: data
});
/* Fetch Invoices */

/* fetching Name */
const fetchingNameSuccess = data => ({
  type: types.FETCHING_NAME_SUCCESS,
  payload: data
});

const fetchingNameError = data => ({
  type: types.FETCHING_NAME_ERROR,
  payload: data
});

const fetchingName = () => ({
  type: types.FETCHING_NAME
});
/* fetching Name */

/* create Edit Statement */
const createEditStatementSuccess = () => ({
  type: types.CREATE_EDIT_STATEMENT_SUCCESS
});

const createEditStatementError = data => ({
  type: types.CREATE_EDIT_STATEMENT_ERROR,
  payload: data
});

const createEditStatement = (request, id, navigate) => ({
  type: types.CREATE_EDIT_STATEMENT,
  payload: { request, id, navigate }
});

/* create Edit Statement */

export {
  fetchingInvoiceList,
  fetchingInvoiceListError,
  fetchingInvoiceListSuccess,
  fetchingStatement,
  fetchingStatementError,
  fetchingStatementSuccess,
  fetchingName,
  fetchingNameError,
  fetchingNameSuccess,
  createEditStatement,
  createEditStatementError,
  createEditStatementSuccess,
  addInvoices,
  removeInvoices,
  clearStore
};
